module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE5IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiM0RDRENEQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTS4yODggNi4zMzRhLjkxOS45MTkgMCAwIDAgMCAxLjMzOWw2LjE3NCA2LjA0N2EuOTgzLjk4MyAwIDAgMCAxLjM3NSAwIC45MzUuOTM1IDAgMCAwIDAtMS4zNDZsLTQuNTItNC40MkgxOC4wM2MuNTQgMCAuOTcxLS40MjIuOTcxLS45NWEuOTU4Ljk1OCAwIDAgMC0uOTcxLS45NTJIMy4zMTdsNC41Mi00LjQyNmEuOTM1LjkzNSAwIDAgMCAwLTEuMzQ2Ljk4My45ODMgMCAwIDAtMS4zNzUgMEwuMjg4IDYuMzM0eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./static/images/back-arrow.svg
// module id = J/6t
// module chunks = 1